import { RawMeasurementQU } from './Common'
import { HarvestYield } from './HarvestYield';

export type HarvestStateObject = {
  area?: RawMeasurementQU;
  avgMoisture?: RawMeasurementQU;
  avgYield?: RawMeasurementQU;
}

export enum HarvestKey {
  YIELD = 'yield',
  MOISTURE = 'moisture',
  DATE = 'harvestdate',
  COMBINE_SPEED = 'combinespeed',
}

export interface HarvestEvents {
  harvestSeasons: string[];
  events: {
    [season: string]: HarvestYield;
  };
}